/**
 * @generated SignedSource<<c664d3de995feefd9036764fea15550f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Step1SelectWorkflowListGithubRepositoriesQuery$variables = {
  integrationId: any;
};
export type Step1SelectWorkflowListGithubRepositoriesQuery$data = {
  readonly listGithubRepositories: ReadonlyArray<any>;
};
export type Step1SelectWorkflowListGithubRepositoriesQuery = {
  response: Step1SelectWorkflowListGithubRepositoriesQuery$data;
  variables: Step1SelectWorkflowListGithubRepositoriesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "integrationId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "integrationId",
        "variableName": "integrationId"
      }
    ],
    "kind": "ScalarField",
    "name": "listGithubRepositories",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Step1SelectWorkflowListGithubRepositoriesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Step1SelectWorkflowListGithubRepositoriesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "94aaa72c1f8e6b59a98360733a3f17f7",
    "id": null,
    "metadata": {},
    "name": "Step1SelectWorkflowListGithubRepositoriesQuery",
    "operationKind": "query",
    "text": "query Step1SelectWorkflowListGithubRepositoriesQuery(\n  $integrationId: GlobalID!\n) {\n  listGithubRepositories(integrationId: $integrationId)\n}\n"
  }
};
})();

(node as any).hash = "1a3ed195e10bd5dce93f267f8cc81e11";

export default node;
